import { AverageCostModalData } from './types';
export const initialAverageCostModalData: AverageCostModalData = {
  newAverageCost: 0,
};
